import FixedPyramidChartAxis from './FixedPyramidChartAxis';

export default FixedPyramidChartAxis;
